<template>
  <div
    class="d-flex"
    style="gap: 8px;"
  >
    <v-btn
      :loading="csvLoading"
      :disabled="csvLoading || xlsxLoading"
      color="secondary"
      outlined
      small
      @click="$emit('download-csv')"
    >
      <v-icon
        left
        small
      >
        {{ icons.mdiFileDelimited }}
      </v-icon>
      CSV
    </v-btn>
    <v-btn
      :loading="xlsxLoading"
      :disabled="csvLoading || xlsxLoading"
      color="secondary"
      outlined
      small
      @click="$emit('download-xlsx')"
    >
      <v-icon
        left
        small
      >
        {{ icons.mdiFileExcel }}
      </v-icon>
      Excel
    </v-btn>
  </div>
</template>

<script>
import { mdiFileDelimited, mdiFileExcel } from '@mdi/js'

export default {
  name: 'DownloadButtons',
  props: {
    csvLoading: {
      type: Boolean,
      default: false,
    },
    xlsxLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: {
        mdiFileDelimited,
        mdiFileExcel,
      },
    }
  },
}
</script>
